module.exports = __webpack_public_path__ + "media/images/buy_box_experts-3c00f3e05d93fcc9f2a0a448b188ff87.png";